import { useState } from "react";
import { useNavigate } from "react-router-dom";
import RegisterView from "./view";
import usePersonalDataForm from "./hooks/usePersonalDataForm";

export default function Register() {
  const navigate = useNavigate();
  
  const [activeStep, setActiveStep] = useState(0);
  
  const goBack = () => {
    if (activeStep === 0) {
      navigate("/");
    } else {
      setActiveStep(1);
    }
  };

  const showOnboarding = async () => {
    const showOnboarding = localStorage.getItem("showOnboarding");
    if (!showOnboarding) {
      localStorage.setItem("showOnboarding", "true");
    }
  }

  const onRegistrationSuccess = () => {
    showOnboarding();
  }
  
  const {
    isDisabled,
    register,
    handleSubmit,
    errors,
    watch,
    setValue,
  } = usePersonalDataForm(navigate, onRegistrationSuccess);

  const goToNextStep = () => {
    setActiveStep(activeStep + 1);
  }

  const goToBeforeStep = () => {
    if (activeStep === 0) {
      navigate("/");
      return;
    }
    setActiveStep(activeStep - 1);
  }

  const jumpSteps = () => {
    setActiveStep(2);
  }

  return <RegisterView
    goBack={goBack}
    isDisabled={isDisabled}
    activeStep={activeStep}
    goToNextStep={goToNextStep}
    jumpSteps={jumpSteps}
    goToBeforeStep={goToBeforeStep}
    register={register}
    errors={errors}
    handleSubmit={handleSubmit}
    watch={watch}
    setValue={setValue}
    onRegistrationSuccess={onRegistrationSuccess}
  />;
}
